import './CaseResolutionFilter.scss';

import { FilterFilled, FilterOutlined } from '@ant-design/icons';
import { useForm } from '@refinedev/antd';
import { Button, Form, Input, Popover } from 'antd';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import FullscreenDrawer from '@/components/general/Drawers/FullscreenDrawer';
import { useUiContext } from '@/contexts/UiContext';
import { Ticket } from '@/model/Ticket/Ticket';
import { TICKET_LOGISTIC_STATE, TicketLogisticStateString } from '@/model/Ticket/TicketConstants';

import useCaseResolutionFilter from './useCaseResolutionFilter';

interface CaseResolutionFilterProps {
  filters: any[];
  setFilters: Function;
  setCurrent: Function;
}

const CaseResolutionFilter = (props: CaseResolutionFilterProps) => {
  const { t } = useTranslation();
  const { isMobile } = useUiContext();
  const { filters, setFilters, setCurrent } = props;
  const [filterPopoverOpen, setFilterPopoverOpen] = useState(false);
  const { formProps } = useForm<Ticket>({ warnWhenUnsavedChanges: false });
  const { form } = formProps;
  const { companySelectProps, machineSelectProps } = useCaseResolutionFilter(formProps, filters);
  const applyFilters = useCallback(
    values => {
      const filters: any[] = [];

      if (values.search) {
        filters.push({
          field: 'search',
          operator: 'eq',
          value: values.search,
        });
      }

      // Empresa
      if (values.empresa) {
        filters.push({
          field: 'empresa',
          operator: 'eq',
          value: values.empresa,
        });
      }

      // Máquina
      if (values.movil) {
        filters.push({
          field: 'movil',
          operator: 'eq',
          value: values.movil,
        });
      }

      // estado
      if (values.logistics_state) {
        filters.push({
          field: 'logistics_state',
          operator: 'eq',
          value: values.logistics_state,
        });
      }

      setFilters(filters, 'replace');
      setCurrent(1);
      setFilterPopoverOpen(false);
    },
    [setFilters, setFilterPopoverOpen, setCurrent],
  );
  const handleClearFilters = useCallback(() => {
    form?.resetFields();
    setFilters([], 'replace');
    setCurrent(1);
    setFilterPopoverOpen(false);
  }, [form, setCurrent, setFilters]);
  const filterContent = (
    <Form
      {...formProps}
      labelAlign="left"
      style={{ marginBottom: 8 }}
      onFinish={applyFilters}
      className="CaseResolutionFilterPopover">
      <div className="CaseResolutionFilterPopoverRows">
        <Form.Item label={t('Buscar')} name={'search'} className="CaseResolutionFilterRow">
          <Input />
        </Form.Item>
        <Form.Item label={t('Empresa')} name={'empresa'} className="CaseResolutionFilterRow">
          {/* <CompanySelector showFullName {...companySelectProps} allowClear showSearch /> */}
          <AntdSelect {...companySelectProps} allowClear showSearch />
        </Form.Item>
        <Form.Item label={t('Máquina')} name={'movil'} className="CaseResolutionFilterRow">
          <AntdSelect {...machineSelectProps} allowClear showSearch />
        </Form.Item>
        <Form.Item label={t('Estado')} name={'logistics_state'} className="CaseResolutionFilterRow">
          <AntdSelect
            options={Object.keys(TicketLogisticStateString)
              .filter(tls => parseInt(tls) !== Number(TICKET_LOGISTIC_STATE.SIN_GESTION_LOGISTICA))
              .map(v => ({
                label: TicketLogisticStateString[parseInt(v)],
                value: parseInt(v),
              }))}
            allowClear
          />
        </Form.Item>
      </div>

      <div className="CaseResolutionFilterActions">
        <Button type="default" style={{ marginLeft: 8 }} onClick={handleClearFilters}>
          {t('Limpiar')}
        </Button>
        <Button htmlType="submit" type="primary">
          {t('Buscar')}
        </Button>
      </div>
    </Form>
  );

  return (
    <div className="CaseResolutionFilter">
      {isMobile ? (
        <>
          <Button
            className={filters.length > 0 ? 'CaseResolutionFilterApplied' : ''}
            onClick={() => setFilterPopoverOpen(true)}
            icon={<FilterOutlined />}
          />
          <FullscreenDrawer
            disablePush
            title={t('Filtros')}
            open={filterPopoverOpen}
            setOpen={setFilterPopoverOpen}>
            {filterContent}
          </FullscreenDrawer>
        </>
      ) : (
        <Popover
          rootClassName="CaseResolutionFilterPopover"
          content={filterContent}
          title={t('Filtros')}
          trigger="click"
          open={filterPopoverOpen}
          onOpenChange={setFilterPopoverOpen}
          placement="bottomRight">
          <Button
            className={filters.length > 0 ? 'CaseResolutionFilterApplied' : ''}
            icon={filters.length > 0 ? <FilterFilled /> : <FilterOutlined />}>
            {t('Filtrar')}
          </Button>
        </Popover>
      )}
    </div>
  );
};

export default CaseResolutionFilter;
